<template>
  <button
    class="btn btn-primary"
    :class="btnClass"
    @click="commitAction"
    :disabled="isLoading"
  >
    <span
      v-if="isLoading"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    {{ localCaption }}
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ActionState } from "@/entities/ActionState";

@Component
export default class AppSubmitButton extends Vue {
  private actionState: ActionState = ActionState.NoAction;

  get localCaption() {
    switch (this.actionState) {
      case ActionState.NoAction:
        return this.caption;

      case ActionState.Loading:
        return "Loading...";

      case ActionState.Succeeded:
        setTimeout(() => {
          this.actionState = ActionState.NoAction;
        }, 1500);
        return "Succeeded!";

      case ActionState.Failed:
        setTimeout(() => {
          this.actionState = ActionState.NoAction;
        }, 1500);
        return "Failed!";

      default:
        throw new Error("Unknown action state!");
    }
  }

  get isLoading() {
    return this.actionState === ActionState.Loading;
  }

  @Prop()
  btnClass!: string;

  @Prop()
  submitAction!: Function;

  @Prop()
  caption!: string;

  async commitAction() {
    if (this.submitAction == null) return;

    try {
      this.actionState = ActionState.Loading;
      await this.submitAction();
      this.actionState = ActionState.Succeeded;
    } catch (e) {
      this.actionState = ActionState.Failed;
    }
  }
}
</script>

<style scoped lang="scss"></style>
